export default __webpack_public_path__ + "static/media/notifications_info.762da695.svg";